import { Box, Stack, Text, Image } from "grommet";
import React, { useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { AliasTile } from "../../aliases/AliasTile";
import { useQueryNumber, useQuerySwitch } from "../../general/Helpers";
import LiveHub from "../../general/LiveHub";
import { AliasMatchParticipantViewModel } from "../../matches/MatchesStore";
import { getTournament } from "../TournamentsStore";
import { getNextMatch } from "../LiveStreamComponents";

import { StarrySkyCanvas, ConstellationCanvas } from "../../components/themes/galaxy/GalaxyComponents";
import { TeamViewModel } from "../../teams/TeamsStore";

export const TournamentTeamPlayersGalaxyWrapper = () => {
    const [ts, setTs] = React.useState(+Date.now());

    let { id, participant } = useParams<{ id: string; participant: string; player: string }>();
    const [participants, setParticipants] = React.useState([] as AliasMatchParticipantViewModel[]);
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match && participant) {
                try {
                    let team = match.participants[+participant]?.team;
                    setTeam(team);
                    if (match.tournamentID) {
                        setParticipants(
                            tournament.participants
                                ?.filter((tournamentParticipant) => tournamentParticipant.teamID == team.id)
                                .flatMap((tournamentParticipant) => {
                                    return tournamentParticipant.aliases?.map(
                                        (tournamentAliasParticipant) =>
                                            ({
                                                alias: tournamentAliasParticipant.alias,
                                                team: team,
                                                aliasID: tournamentAliasParticipant.aliasID,
                                                id: tournamentAliasParticipant.id,
                                                teamID: team.id,
                                                teamName: team.name,
                                                participantID: tournamentParticipant.id,
                                                stats: [],
                                            } as AliasMatchParticipantViewModel)
                                    );
                                }) || []
                        );
                    } else {
                        setParticipants(match.participants[+participant]?.aliases || []);
                    }
                } catch (e) {
                    setParticipants([]);
                }
            } else {
                setParticipants([]);
            }
            console.log("interactive");
        });
    };

    const useTeamColor = useQuerySwitch("useTeamColor");

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <Box justify="evenly" direction="row" background={{ image: `url(${team.logoUri})`, opacity: 0.05 }}>
                <Stack fill anchor="left" guidingChild={1}>
                    <StarrySkyCanvas color={useTeamColor ? team?.color || "white" : "white"}></StarrySkyCanvas>
                    <Box direction="row" justify="evenly">
                        {participants.map((participantAlias) => (
                            <Stack key={participantAlias.id} anchor="center">
                                <Box justify="center" align="center" style={{ minHeight: "100vh" }}>
                                    {participantAlias.alias.profileUri && (
                                        <Image src={participantAlias.alias.profileUri + "?ts=" + ts} width={"350px"} height={"350px"} style={{ objectFit: "contain" }}></Image>
                                    )}
                                    {!participantAlias.alias.profileUri && <Image src={"/images/faces/blank.png"} width={"350px"}></Image>}
                                    <Text size="28px" style={{ fontFamily: "Calamity" }}>
                                        {participantAlias.alias.name.toUpperCase()}
                                    </Text>
                                </Box>
                                <ConstellationCanvas
                                    camera={{ position: [0, 20, 25], fov: 60 }}
                                    color={useTeamColor ? team?.color || "white" : "white"}
                                    style={{ height: "100vh", width: "40vw", left: "-165px" }}
                                ></ConstellationCanvas>
                            </Stack>
                        ))}
                    </Box>
                </Stack>
            </Box>
        </LiveHub>
    );
};
